export const LANGUAGE_MAP = {
  de: "German",
  es: "Spanish",
  en: "English",
  fr: "French",
  it: "Italian",
  ru: "Russian"
};



// WEBPACK FOOTER //
// ./template/components/CountrySelector/constants.js